export const days = [
  ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  ['Недiля', 'Понедiлок', 'Вiвторок', 'Середа', 'Четвер', "П'ятниця", 'Субота'],
];
export const months = [
  [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'Novermber',
    'December',
  ],
  [
    'Ciчня',
    'Лютого',
    'Березня',
    'Квiтня',
    'Травня',
    'Червня',
    'Липня',
    'Серпня',
    'Вересня',
    'Жовтня',
    'Листопада',
    'Грудня',
  ],
];
